import { IdentitySourceConfig } from './IdentityConfig';
import { StepConfig } from './StepConfig';
import { TriggerConfig } from './TriggerConfig';

/**
 * This is the configuration of a workflow. Workflows are made up of steps and triggers.
 * Triggers are events used to trigger the execution of steps.
 *
 * @public
 *
 * @remarks
 * When the Samelogic SDK is initialized, the workflow configuration is loaded and executed immediately.
 * This means that the trigger will be setup to listen for the configured events. When all of the event conditions are met,
 * the workflow will execute the configured steps.
 */
export interface WorkflowConfig {
  /**
   * The name given to the workflow.
   */
  name: string;

  /**
   * Optional for identification
   */
  id?: string;

  /**
   * Endpoint where all triggers and events will be logged to
   */
  logEndpoint?: string;

  /**
   * A list of events or conditions that needs to be met to trigger the execution of the steps.
   * If this is not specified, the trigger will be executed immediately. The order of the trigger is not
   * taken into account.
   */
  triggers?: TriggerConfig[];
  /**
   * The configuration of all the steps to be executed when the trigger is fired.
   */
  steps: StepConfig[];

  identitySource?: IdentitySourceConfig;
}
